import React from 'react';
import { useBreakpoint } from '~/hooks/useBreakpoint';

/**
 * Week days header component for the calendar grid
 * Displays Monday-Sunday header row
 */
const WeekDaysHeader = React.memo(() => {
  const weekDays = [
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
    'Sunday',
  ];

  const { isMobile } = useBreakpoint();

  return (
    <div className='grid h-full grid-cols-7 bg-gray-100 scrollbar-gutter-stable'>
      {weekDays.map((day) => (
        <div
          key={day}
          className='overflow-x-hidden border-r border-gray-200 px-2 pb-3 pt-3.5 text-center last:border-r-0'
        >
          <span className='text-sm font-medium text-gray-700'>
            {isMobile ? day.slice(0, 3) : day}
          </span>
        </div>
      ))}
    </div>
  );
});

WeekDaysHeader.displayName = 'WeekDaysHeader';

export { WeekDaysHeader };
